// Helper function to convert kebab-case to UPPER_SNAKE_CASE
import {AvailableAction} from "../api/ApiTypes.ts";

export const convertKebabToEnumAction = (kebabAction: string | undefined): AvailableAction | undefined => {
    if (!kebabAction) return undefined;

    // Convert kebab-case to UPPER_SNAKE_CASE
    const upperSnakeCase = kebabAction.replace(/-/g, '_').toUpperCase();

    // Check if the converted string is a valid enum value
    if (Object.values(AvailableAction).includes(upperSnakeCase as AvailableAction)) {
        return upperSnakeCase as AvailableAction;
    }

    console.info(`Invalid action: ${kebabAction} converted to ${upperSnakeCase}`);
    return undefined;
};

export const getValue = <T>(value: T | null | undefined, fallback: string = 'N/A'): T | string => {
    // Consider empty strings as needing fallback too for text values
    if (value === null || value === undefined || value === '') {
        return fallback;
    }
    return value;
};

export const prettyFormatUnknownEnum = (str: string | null | undefined): string => {
    // 1. Guard against null/undefined/empty
    if (!str) return '';

    // 2. Short-circuit for short strings
    if (str.length < 4) return str;

    return str
        .split("_")
        .filter(Boolean) // 3. Removes empty strings from double underscores "__"
        .map(word => {
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join(" ");
};